import React, { Component } from 'react';
import BallThrownDog from './ballThrownDog';
import { fire } from "../Firebase/firebase";

export default class ballsCaught extends Component {

constructor(props) {
    super(props);
    this.state = {
      ballsCaught: []
    };
  }


componentDidMount(){
	this.getBallsCaught();
}


goBack=()=>{
    this.props.history.goBack();
    console.log("back")
	}

// Gets entries in users own database
getBallsCaught = () => {

    let query = fire
      .database()
      .ref("users/" + this.props.location.state.user.uid + "/balls_caught")
      .orderByKey();
    query.once("value").then(snapshot => {
     this.setState({ballsCaught: []})
      snapshot.forEach((childSnapshot, data) => {
        const user = {
          id: childSnapshot.val().uid,
          name: childSnapshot.val().name,
          avatar: childSnapshot.val().avatar
        };
        this.setState({ ballsCaught: [...this.state.ballsCaught, user] }, function(){console.log(this.state.ballsCaught)});
      });
    });
  };
	
handleDelete = (uid) => {
console.log("Delete");
    let query = fire
      .database()
      .ref("users/" + this.props.location.state.user.uid + "/balls_caught")
      .orderByKey();
    let ref = fire.database().ref("users/" + this.props.location.state.user.uid + "/balls_caught");

    query.once("value").then(snapshot => {
      snapshot.forEach((childSnapshot, data) => {
          let key = childSnapshot.key;
          
          if(childSnapshot.val().uid === uid){
            console.log("Deletion made");
            ref.child(key).remove();
            this.getBallsCaught();
          }
      });
    });
  };



render(){
	return(
			<div className="container">
					
			<i onClick={this.goBack} className="arrow left"></i>
			<h1 id="dog-title">Balls Caught Today</h1>
			<div className="dog-container">
				{this.state.ballsCaught.map(data=> <BallThrownDog key={data.id} name={data.name} avatar={data.avatar} uid= {data.id} handleDelete= {this.handleDelete} currentUser={this.props.location.state.user}/>)}

				</div>	
			</div>

		)
}
}